import React from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router';
import { History } from 'history';
import { Trans } from '@lingui/macro';

import { Button } from 'components/AntD';
import './styles.less';

interface GoBackProps {
  className?: string;
  history?: History;
  onClick?: () => void;
}

const GoBack = ({ className = '', onClick, history }: GoBackProps): JSX.Element | null => {
  const defaultHistory = useHistory();
  const thisHistory = history || defaultHistory;

  return thisHistory.length > 2 ? (
    <Button
      variant="text"
      icon={<span>&#8592;</span>}
      className={classNames('tw-block go-back-button tw-my-2', className)}
      onClick={onClick || thisHistory.goBack}
    >
      <Trans>
        <span className="go-back-text">Back</span>
      </Trans>
    </Button>
  ) : null;
};

export default GoBack;
